/**
 * The platform's own domain, from VITE_PLATFORM_DOMAIN.
 *
 * Never hardcoded: this code was forked from GrassrootsFC, and used to link
 * and route by its hostname. The fallback cannot resolve on purpose.
 */
export const PLATFORM_DOMAIN = import.meta.env.VITE_PLATFORM_DOMAIN || 'allgrassroots.invalid';
